<template>
    <h1 class="text-2xl text-black dark:text-white">
        <slot></slot>
    </h1>
</template>

<script>
export default {
    props: {
    },
};
</script>
